<template>
  <div class="left-chart-3">
    <div class="lc1-header">线上参与人数</div>
    <div class="lc1-details">
        <!-- <span>1234567</span> -->
        <dv-digital-flop :config="config" />
    </div>
    <dv-decoration-2 style="height:10px;" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LayoutLeft3',
  data () {
    return {
      all: {
        scene: 100,
        attendance: 10000,
      },
      alldata: {},
      config: {
        animationFrame: 450,
        number: [1234567],
        content: '{nt}人次'
      },
      config1: {
        animationFrame: 450,
        number: [1234567],
        content: '{nt}人次'
      },
      config2: {
        animationFrame: 450,
        number: [1234567],
        content: '{nt}人次'
      }
    }
  },
  mounted() {
    this.loadList()

    var ro = 0;
    setInterval(() => {
        if (ro > 0) {
            ro = 0
            const inc = this.getRandomInt(0, 10);
            this.$store.dispatch('incdata', this.$store.state.incdata + inc)
            this.config2.number[0] = this.config.number[0] + inc
            this.config = this.config2
        } else {
            ro = 1
            const inc = this.getRandomInt(0, 10)
            this.$store.dispatch('incdata', this.$store.state.incdata + inc)
            this.config1.number[0] = this.config.number[0] + inc
            this.config = this.config1
        }
    }, 10000);
  },
  methods: {
      getRandomInt(min, max) {
          min = Math.ceil(min); // 确保最小值是整数  
          max = Math.floor(max); // 确保最大值是整数  
          return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      loadList() {
          var that = this;
          axios.get(this.$store.state.config.host + "/v1/block/" + window.encodeURI('数据大屏_概览数据') + '/?cid=4000').then(response => {
              //   that.alldata = response.data.data;
              Object.values(response.data.data).forEach(element => {
                  that.alldata[element.title] = element.title1;
              });
              const num = Number(that.alldata['线上参与人数']);
              that.config.number[0] = num;
              that.config1.number[0] = num;
              that.config2.number[0] = num;
          })
      },
  }
}
</script>

<style lang="less">
.left-chart-3 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;

  .lc1-header {
    text-align: center;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    margin-bottom: 20px;
  }

  .lc1-details {
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 30px;
      margin-left: 20px;
    }
  }

}
</style>

